export const INTRO_CONSTANTS = {
  title: "Next-Gen Cloud Security Posture Management ",
  text: "Cloud environments grow fast—and so do misconfigurations. OneMind delivers a proactive approach to securing your cloud posture through automated configuration analysis, risk prioritization, and compliance mapping across your entire infrastructure. ",
};
